import { useMemo } from 'react'

import {
  AqsiDiagnosticsPanel,
  aqsiProfile,
  makeSelectAqsiDiagnosticsVm,
  type AqsiDiagnosticsActions,
  type AqsiResourceArgs,
} from '@krp/resource-aqsi-ui'

import { useAppSelector } from '../../app/hooks'
import type { RootState } from '../../app/types'

/** Binding панели диагностики кабинета AQSI в карточке ресурса Platform: rid — явно от окна. */
export function AqsiDiagnosticsBinding({ resourceId }: { resourceId: string }) {
  const args = useMemo<AqsiResourceArgs>(() => ({ resourceId }), [resourceId])
  const profileSubscription = aqsiProfile.useQuerySubscription(args)

  const selectProfile = useMemo(() => aqsiProfile.select(args), [args])
  const profile = useAppSelector((state: RootState) => selectProfile(state))
  const selectVm = useMemo(() => makeSelectAqsiDiagnosticsVm(), [])
  const vm = selectVm({ profile })

  const refetchProfile = profileSubscription.refetch
  const actions = useMemo<AqsiDiagnosticsActions>(
    () => ({
      reload: () => {
        void refetchProfile()
      },
    }),
    [refetchProfile],
  )
  return <AqsiDiagnosticsPanel vm={vm} actions={actions} />
}
